<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'
import { PageMethods } from '@state/modules/page'
import Constants from '@constants'
export default {
  name: 'PatchModule',
  page() {
    return {
      title: this.$tc('patch'),
    }
  },
  beforeRouteLeave(to, from, next) {
    // add any module level clean up logic here
    setTimeout(() => {
      if (this.patchPageReset) {
        this.patchPageReset()
      }
    }, 400)
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.availableModulesInLicense.indexOf(Constants.PATCH) === -1) {
        return vm.$router.replace({ name: 'upgrade-plan' })
      }
      if (vm.myAllowedModules.indexOf(Constants.PATCH) === -1) {
        return vm.$router.replace({ name: '404' })
      }
    })
  },
  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,
  },

  methods: {
    ...PageMethods,
  },
}
</script>
